import React, { useState, useEffect } from "react";
import Content from "../../../components/Content";
import { MaterialDetailsTabs } from "../../../constants/MaterialConstants";
import { MaterialOverviewView } from "./MaterialOverviewView";

export const MaterialDetailsView = () => {
  const [lastTab, setLastTab] = useState(1);

  useEffect(() => {
    let lastTab = JSON.parse(localStorage.getItem("lastTab"));
    if (lastTab) {
      setLastTab(lastTab);
    }
  }, []);

  return (
    <>
      <Content
        tabs={true}
        tabList={MaterialDetailsTabs}
        lastTab={lastTab}
        title={"Material"}
      >
        <div value={1}>
          <MaterialOverviewView />
        </div>
        <div value={2}></div>
      </Content>
    </>
  );
};
